import { SuitabilityIcon } from '@zefr/style-guide/dist/ui/icons/internalApps';
import React from 'react';
import { getIfUserHasPermissionsFunc } from '../../../src/helpers/pluginHandling/helpers';
import { SITE_APP_DEMO, TopNavTab } from '../../gatsby-theme-zefr/types/shared';
import {  DEMO_BASE_URL } from '../routes/routes';



export const demoTab: TopNavTab = {
  target: '_self',
  icon: <SuitabilityIcon />,
  label: 'growth.demo.title', // Label can be a key in the common namespace for the resource bundle as well
  link: `${DEMO_BASE_URL}`,
  value: SITE_APP_DEMO,
};

export const getDemoTab: getIfUserHasPermissionsFunc<TopNavTab> = (user) => {
  if (user?.authenticated) {
    return demoTab;
  }
  return undefined;
};
